import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { NAV_ITEMS } from '../../data/navigation';
import './Footer.css';

const EMAIL = 'puzziwuzzi@gmail.com';

const socialLinks = [
    { icon: faInstagram, url: 'https://www.instagram.com/puzziwuzzi', label: 'instagram', handle: '@puzziwuzzi' },
    { icon: faFacebook, url: 'https://www.facebook.com/puzziwuzzi', label: 'facebook', handle: '/puzziwuzzi' },
    { icon: faTwitter, url: 'https://www.twitter.com/puzziwuzzi', label: 'twitter', handle: '@puzziwuzzi' }
];

const Footer: React.FC = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-inner">
                <div className="footer-block footer-block-brand">
                    <Link to="/" className="footer-wordmark">
                        static<span className="footer-wordmark-dot">.</span>noise
                    </Link>
                    <p className="footer-blurb">
                        Collages cut out of second-hand books, flea-market
                        photographs and found paper. Every piece lists what it
                        was made from.
                    </p>
                </div>

                <nav className="footer-block" aria-label="Footer">
                    <h2 className="footer-heading">index</h2>
                    <ul className="footer-list">
                        {NAV_ITEMS.map((item, index) => (
                            <li key={item.path}>
                                <Link to={item.path} className="footer-link">
                                    <span className="footer-link-index" aria-hidden="true">
                                        {String(index + 1).padStart(2, '0')}
                                    </span>
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="footer-block">
                    <h2 className="footer-heading">elsewhere</h2>
                    <ul className="footer-list">
                        {socialLinks.map(link => (
                            <li key={link.url}>
                                <a
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="footer-link"
                                >
                                    <FontAwesomeIcon
                                        icon={link.icon}
                                        className="footer-link-icon"
                                        aria-hidden="true"
                                    />
                                    {link.label}
                                    <span className="footer-link-meta">{link.handle}</span>
                                    <span className="sr-only"> (opens in a new tab)</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="footer-block">
                    <h2 className="footer-heading">say something</h2>
                    <a className="footer-email" href={`mailto:${EMAIL}`}>
                        {EMAIL}
                    </a>
                </div>
            </div>

            <div className="footer-baseline">
                <span>© {year} static.noise</span>
                {/* Drawn in CSS rather than set in block characters: the
                    monospace stack has no glyph for those, so they came out
                    as tofu at whatever width the fallback font chose. */}
                <span className="footer-signal" aria-hidden="true">
                    no signal, only noise
                </span>
            </div>
        </footer>
    );
};

export default Footer;
